import { FC } from 'react';
import { DozukiHeader, Link } from '~/ui-components';
import { useSiteInfo } from '~/pages/_shared';
import { useLoggedInUser } from '~/pages/_shared/useLoggedInUser';
import { useLocalization } from '~/framework';
import { useMarkNotificationAsRead } from './useMarkNotificationAsRead';
import { useMarkAllNotificationsAsRead } from './useMarkAllNotificationsAsRead';
import { useRecentNotifications } from './useRecentNotifications';
import { useRouter } from 'next/router';
import { Box, useToast } from '@chakra-ui/react';
import { useActiveNavItem } from '../ActiveNavItemContext';
import { useResourceCenter } from './useResourceCenter';

export const Header: FC = () => {
   const { data: siteInfo } = useSiteInfo();
   const { data: user } = useLoggedInUser();
   const router = useRouter();
   const activeNavItem = useActiveNavItem();
   const toast = useToast();

   const { flattenedData: notifications, total: totalUnreadNotifications } =
      useRecentNotifications();
   const markNotificationAsRead = useMarkNotificationAsRead();
   const markAllNotificationsAsRead = useMarkAllNotificationsAsRead();

   const { _js, translationSettings, handleTranslationSettingsChange } = useLocalization();

   function handleMarkAllNotificationsAsRead() {
      markAllNotificationsAsRead.mutate();
   }

   function handleMarkNotificationAsRead(notificationid: string) {
      markNotificationAsRead.mutate(notificationid);
   }

   const onRedirect = (url: string) => {
      router.push(url);
   };

   const customHeaderHtml = siteInfo?.['appearance-header'];
   const siteLogoUrl = siteInfo?.logo?.image.standard;
   const siteTitle = siteInfo?.title;

   // Determine if we should show the Resource Center button
   const conditionalProps: any = {};
   const resourceCenter = useResourceCenter();

   if (resourceCenter) {
      conditionalProps.onResourceCenterSelected = () => {
         resourceCenter.show();
      };
   }

   return (
      <>
         {customHeaderHtml && (
            <Box
               id="customHeader"
               aria-label="custom-header"
               dangerouslySetInnerHTML={{
                  __html: customHeaderHtml,
               }}
            />
         )}
         <DozukiHeader
            siteLogoUrl={siteLogoUrl}
            LinkComponent={Link}
            permissions={user?.permissions}
            siteTitle={siteTitle}
            user={user}
            siteConfiguration={siteInfo}
            notifications={notifications}
            totalUnreadNotifications={totalUnreadNotifications}
            onMarkAllNotificationsAsRead={handleMarkAllNotificationsAsRead}
            onMarkNotificationAsRead={handleMarkNotificationAsRead}
            userTranslationSettings={translationSettings}
            onUserTranslationsSettingsChange={handleTranslationSettingsChange}
            onRedirect={onRedirect}
            _js={_js}
            toast={toast}
            activeItem={activeNavItem}
            {...conditionalProps}
         />
      </>
   );
};
